/**
 * ops セクションの閲覧アクセス判定。ops 依頼は顧客対応の自由記述（背景 / 対応依頼）を含むため、
 * **社内従業員のみ** に read を開放し、社外扱いのアカウント（外部 / 退職者 / システムアカウント）を
 * 除外する。判定は Google Workspace 同期の `division`（orgUnitPath 先頭セグメント）に基づく。ops は
 * 社内では機密ではないため部署単位の細分化はせず、「社外に見えない」ことだけを担保する。判定は
 * **fail-closed**（division 未設定 = null/undefined は拒否）。初回ログイン直後の自動プロビジョニングは
 * division を持たない最小ドキュメントを作るため（firestore-user-repository の ensureDefaultPortalRole）、
 * 未同期アカウントを外部協力者と区別できない。Workspace 同期で実 division が入るまでは deny 側に倒す
 * （既存の isPiDivOrAdmin も null division を fail-closed で扱うのと同じ方針）。書き込み（担当者変更 /
 * ローテーション更新）は別途 PI Div / admin にゲートする。frontend（page-access）と product-api
 * （ミドルウェア）が同じ判定を参照するための単一 source。
 * @graph-stack ops-core
 * @graph-domain Operations
 * @graph-business ops 閲覧を社内従業員に限定する判定（外部 / 退職者 / システムアカウント division を除外）。frontend と API で共有
 * @graph-connects none
 */
/**
 * 社外扱いの division（orgUnitPath 先頭セグメント）。これらは ops 閲覧から除外する。
 * `退職者（一時退避）` は退職者の一時退避 OU。ラベルは Google Workspace の OU 名に一致させる。
 * @graph-connects none
 */
export const OPS_NON_EMPLOYEE_DIVISIONS = new Set([
    '外部',
    '退職者（一時退避）',
    'システムアカウント',
]);
/**
 * ops 依頼を閲覧できる社内従業員か判定する。fail-closed: division 未設定（null / undefined、＝未同期の
 * 新規アカウント）と社外扱いの division（外部 / 退職者 / システムアカウント）を拒否し、それ以外の
 * 実 division を持つアカウントのみ社内従業員として許可する。
 *
 * `options.isAdmin` を渡すと admin は division を問わず許可する（CTO は OU ルート直下に置かれるため
 * division が null になり、fail-closed のままだと全画面を見られるはずの人だけが ops を見られない）。
 * @graph-connects none
 */
export function isOpsInternalViewer(division, options = {}) {
    // **admin は division を問わず許可する。** CTO のように特定の division に属さない
    // アカウント（Firestore `users.division` が null）は、社外ではないのに fail-closed で
    // 弾かれていた。他の判定（`isInternalPortalMember` 等）は既に admin を division 不問で
    // 通しており、ops だけが揃っていなかった。
    if (options.isAdmin === true)
        return true;
    if (division === null || division === undefined) {
        return false;
    }
    return !OPS_NON_EMPLOYEE_DIVISIONS.has(division);
}
//# sourceMappingURL=access.js.map